import { LegalLayout } from "@/components/legal/LegalLayout";
import { LegalP, LegalSection, LegalUl } from "@/components/legal/LegalProse";
import { CONTACT, OPERATOR, formatAddress } from "@/lib/legal";
import { tw } from "@/lib/theme";

export function CopyrightPage() {
  return (
    <LegalLayout
      title="Copyright & IP"
      subtitle="Reporting infringement on user-uploaded content."
    >
      <LegalSection title="Respect creators">
        <LegalP>
          Post only content you created or have permission to use. {OPERATOR.product} responds to
          valid copyright and trademark complaints under applicable Indian law and international
          norms.
        </LegalP>
      </LegalSection>

      <LegalSection title="Submit a notice">
        <LegalP>Email a takedown request to:</LegalP>
        <LegalUl
          items={[
            <>
              <a href={`mailto:${CONTACT.admin}`} className={tw.link}>
                {CONTACT.admin}
              </a>{" "}
              or{" "}
              <a href={`mailto:${CONTACT.support}`} className={tw.link}>
                {CONTACT.support}
              </a>
            </>,
            "Subject line: Copyright / IP notice",
            "Your full name and contact details",
            "Description of the copyrighted work",
            "URL(s) or post ID(s) on Daywia that infringe",
            "A statement of good-faith belief that use is unauthorized",
            "A statement that information is accurate and you are authorized to act",
          ]}
        />
      </LegalSection>

      <LegalSection title="Counter-notice">
        <LegalP>
          If your content was removed in error, reply to the same addresses with your counter-
          notice, proof of rights, and willingness to accept jurisdiction in Kadapa, Andhra
          Pradesh, India.
        </LegalP>
      </LegalSection>

      <LegalSection title="Designated contact">
        <LegalP>
          {OPERATOR.name}
          <br />
          {formatAddress()}
          <br />
          {CONTACT.admin}
        </LegalP>
      </LegalSection>

      <LegalSection title="Repeat infringers">
        <LegalP>
          Accounts with repeated valid infringement notices may be terminated under our Terms.
        </LegalP>
      </LegalSection>
    </LegalLayout>
  );
}
